import { useEffect } from 'react';

const ColorInit = ({ color }) => {
   // console.log(color); 
    useEffect(() => {
        // Remove existing classes to prevent conflicts
        document.documentElement.classList.remove('color-two', 'color-bigmall');

        if (color === true) {
            document.documentElement.classList.add('color-bigmall');
            localStorage.setItem('theme', 'color-bigmall');
        } else if (color === "bigmall") {  // Correct usage of else if
            document.documentElement.classList.add('color-bigmall');
            localStorage.setItem('theme', 'color-bigmall');
        } else {
            localStorage.removeItem('theme');
        }
    }, [color]);

    return null;
};

export default ColorInit;
